import Service, { inject as service } from '@ember/service';

class OembedCommands extends Service {
  @service api;

  /**
   * Get thumbnail from oembed endpoint
   *
   * @param {String} url
   * @param {boolean} cloudinaryCacheAndServe
   * @returns {*}
   */
  getThumbnail(url, cloudinaryCacheAndServe = false) {
    const options = {
      params: {
        url,
      }
    };

    // is more costly as it will cache with transforms
    if (cloudinaryCacheAndServe) {
      options.params['cloudinary_cache_and_serve'] = cloudinaryCacheAndServe;
    }

    return this.api.request('oembed/get-thumbnail', options);
  }
}

export default OembedCommands;
